import { useTranslations } from "@/i18n/useTranslations";
import partnerImage1 from "@/assets/img/clients/clients-1.webp";
import partnerImage2 from "@/assets/img/clients/clients-2.webp";
import partnerImage3 from "@/assets/img/clients/clients-3.webp";
import partnerImage5 from "@/assets/img/clients/clients-5.webp";
import partnerImage6 from "@/assets/img/clients/clients-6.webp";
import partnerImage7 from "@/assets/img/clients/clients-7.webp";
import partnerImage8 from "@/assets/img/clients/clients-8.webp";
import partnerImage9 from "@/assets/img/clients/clients-9.webp";
import AppImage from "@/lib/AppImage";
import { BASE_URL, FetchInstance } from "@/api/FetchInstance";
import { useEffect, useState } from "react";

interface Partner {
  id: number;
  name: string;
  logo: string;
  created_at: string;
  updated_at: string;
}

interface PartnersResponse {
  status: number;
  success: boolean;
  data: Partner[];
}

type Slide = {
  key: string;
  src: string | { src: string };
  alt: string;
};

const STATIC_TRACK_1: Slide[] = [
  { key: "s1", src: partnerImage1, alt: "Client 1" },
  { key: "s2", src: partnerImage2, alt: "Client 2" },
  { key: "s3", src: partnerImage3, alt: "Client 3" },
  { key: "s5", src: partnerImage5, alt: "Client 5" },
  { key: "s6", src: partnerImage6, alt: "Client 6" },
  { key: "s7", src: partnerImage7, alt: "Client 7" },
];

const STATIC_TRACK_2: Slide[] = [
  { key: "s8", src: partnerImage8, alt: "Client 8" },
  { key: "s9", src: partnerImage9, alt: "Client 9" },
  { key: "s1b", src: partnerImage1, alt: "Client 1" },
  { key: "s2b", src: partnerImage2, alt: "Client 2" },
  { key: "s3b", src: partnerImage3, alt: "Client 3" },
];

function PartnerSlide({ slide }: { slide: Slide }) {
  return (
    <div className="clients-slide !bg-[#0085d4] dark:!bg-gray-800">
      <AppImage
        src={slide.src}
        className="img-fluid"
        alt={slide.alt}
        width={120}
        height={80}
      />
    </div>
  );
}

/** Bir xil ketma-ketlikni ikki marta chiqaradi — translateX(-50%) uzluksiz aylanadi */
function MarqueeTrack({
  slides,
  trackClass,
  aos,
}: {
  slides: Slide[];
  trackClass: string;
  aos: "fade-right" | "fade-left";
}) {
  const loop = [...slides, ...slides];
  const duration = Math.max(slides.length * 4, 20);

  return (
    <div className="clients-slider">
      <div
        className={`clients-track ${trackClass}`}
        data-aos={aos}
        data-aos-delay="200"
        style={{ animationDuration: `${duration}s` }}
      >
        {loop.map((slide, index) => (
          <PartnerSlide key={`${slide.key}-${index}`} slide={slide} />
        ))}
      </div>
    </div>
  );
}

const PartnersSection = () => {
  const t = useTranslations("partners");
  const [partners, setPartners] = useState<Partner[]>([]);

  useEffect(() => {
    const getPartners = async () => {
      try {
        const res = await FetchInstance<PartnersResponse>("/api/partners/list");
        if (res?.success && res?.data) {
          setPartners(res.data);
        }
      } catch (error) {
        console.error("Error fetching partners:", error);
      }
    };

    getPartners();
  }, []);

  const apiSlides: Slide[] = partners.map((partner) => ({
    key: `api-${partner.id}`,
    src: `${BASE_URL}/storage/${partner.logo}`,
    alt: partner.name,
  }));

  return (
    <section className="clients section py-[200px] bg-transparent">
      <div id="clients">
        <div
          className="container xl:px-[90px] section-title"
          data-aos="fade-up"
        >
          <h2
            className="text-black dark:!text-white"
            data-uz="INNOWEEK"
            data-ru="INNOWEEK"
            data-en="INNOWEEK"
          >
            {t("INNOWEEK")}
          </h2>
          <div className="text-black dark:!text-white">{t("PARTNERS")}</div>
        </div>

        <MarqueeTrack
          slides={[...STATIC_TRACK_1, ...apiSlides]}
          trackClass="track-1"
          aos="fade-right"
        />
        <MarqueeTrack
          slides={[...STATIC_TRACK_2, ...apiSlides]}
          trackClass="track-2"
          aos="fade-left"
        />
      </div>
    </section>
  );
};

export default PartnersSection;
